import { Tooltip } from 'react-tooltip'

import { POINTS_DETAIL_TOOLTIP, UNWRAPPED_TOKEN_TOOLTIP } from '@src/constants/exchange'

export function AllTooltips() {
    return (
        <>
            <Tooltip
                id='unwrapped-token-notification-tooltip'
                style={{ zIndex: 1000, maxWidth: '300px' }}
                render={() => <p className='text-xs'>{UNWRAPPED_TOKEN_TOOLTIP}</p>}
            />
            <Tooltip
                id='points-detail-tooltip'
                style={{ zIndex: 1000, maxWidth: '300px' }}
                render={() => <p className='text-xs'>{POINTS_DETAIL_TOOLTIP}</p>}
            />
        </>
    )
}
